import MultiSelect from './MultiSelect.component';
export default MultiSelect;